import { Link, useLocation } from 'react-router';

export const NavigationItem = ({ linkTo, navigationLabel }: { linkTo: string; navigationLabel: string }) => {
  const location = useLocation();
  const currentView = () => {
    switch (location.pathname) {
      case `/admin/user-access-management`:
        return 'User access management';
      case `/admin/remove-academics`:
        return 'Remove academics';
      case `/admin/remove-units`:
        return 'Remove units';
      case `/admin/school-parameters`:
        return 'Modify school parameters';
      case `/admin/data-load`:
        return 'Data load';
      case `/admin/disciplines`:
        return 'Disciplines';
      case `/admin/update-staff-details`:
        return 'Update staff details';
      default:
        return 'User access management';
    }
  };
  return (
    <div className="group relative">
      <Link className={currentView() === navigationLabel ? 'text-lime' : ''} to={linkTo}>
        {navigationLabel}
      </Link>
      <div
        className={`${currentView() === navigationLabel ? 'opacity-100' : 'opacity-0'} absolute -bottom-[20px] left-0 h-1 w-full bg-lime
          transition-opacity duration-300 group-hover:opacity-100`}
      ></div>
    </div>
  );
};
